import React, {useState} from 'react'
import PropTypes from 'prop-types'
import WissensportalAusbilderTrainerOverview from '#components/o/Wissensportal/WissensportalAusbilderTrainerOverview'
import WissensportalAusbilderTrainerSingle from '#components/o/Wissensportal/WissensportalAusbilderTrainerSingle'

function WissensportalAusbilderTrainer({azubiId}) {
  const [selectedFilters, setFilters] = useState({courses: [], modules: [], status: ''})
  if (!!azubiId) {
    return <WissensportalAusbilderTrainerSingle azubiId={azubiId} selectedFilters={selectedFilters} setFilters={setFilters}/>
  }
  return <WissensportalAusbilderTrainerOverview selectedFilters={selectedFilters} setFilters={setFilters}/>
}

WissensportalAusbilderTrainer.propTypes = {
  azubiId: PropTypes.number,
}

export default WissensportalAusbilderTrainer
